import {EXCEL_MIME_TYPES} from '../../utils/extensions';
import {IStationApi} from '../../api/station-api.service';
import {IS3UploadService} from '../../utils/s3-upload.service';
import {IImomoErrorService} from '../../error/error.service';
import {IMeteostationHistoricNormEvents} from '../../meteostation/historic-norm/historic-norm.controller';

enum IDataFileState {
  Unselected, Selected, Validating, Invalid, Valid
}

interface IDataFileIcon {
  name:string,
  cssClass:string
}

export default class StationCreatorDataController {
  static $inject = ['s3UploadService', 'stationApi', 'imomoErrorService'];

  dataFile:File;
  dataFileState:IDataFileState;
  onChange:(callbackArgs:{
    dataFile:File, isValid:boolean}) => void;

  constructor(private s3UploadService:IS3UploadService,
              private stationApi:IStationApi,
              private imomoErrorService: IImomoErrorService) {
    this.dataFileState = IDataFileState.Unselected;
  }

  get isUnselected() {
    return this.dataFileState == IDataFileState.Unselected;
  }

  get isValidating() {
    return this.dataFileState == IDataFileState.Validating;
  }

  get isInvalid() {
    return this.dataFileState == IDataFileState.Invalid;
  }

  get isValidated() {
    return this.dataFileState == IDataFileState.Valid;
  }

  get excelMimeTypes() {
    return EXCEL_MIME_TYPES;
  }

  get dataFileStateIcon():IDataFileIcon {
    switch (this.dataFileState) {
      case IDataFileState.Selected:
        return {
          name: 'indeterminate_check_box',
          cssClass: ''
        };
      case IDataFileState.Validating:
        return {
          name: 'cached',
          cssClass: ''
        };
      case IDataFileState.Valid:
        return {
          name: 'check_circle',
          cssClass: 'md-accent'
        };
      case IDataFileState.Invalid:
        return {
          name: 'error_outline',
          cssClass: 'md-warn'
        };
      default:
        return {
          name: '',
          cssClass: ''
        };
    }
  }

  onDataFileChange = (files:Array<File>) => {
    if (files && files[0]) {
      this.dataFile = files[0];
      this.dataFileState = IDataFileState.Selected;
    } else {
      this.dataFileState = IDataFileState.Unselected;
      this.dataFile = null;
    }
    this.notifyChange(false);
  };

  validate():ng.IPromise<void> {
    this.dataFileState = IDataFileState.Validating;
    return this.stationApi.validateDischargeData(this.dataFile)
        .then(() => {
          this.dataFileState = IDataFileState.Valid;
          this.notifyChange(true);
        })
        .catch((error) => {
          this.imomoErrorService.showErrorDetailsDialog(error.data.details);
          this.dataFileState = IDataFileState.Invalid;
          this.notifyChange(false);
        });
  };



  private notifyChange(valid:boolean) {
    if (this.onChange) {
      this.onChange({
        dataFile: this.dataFile,
        isValid: valid
      });
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/station/creator/data.controller.ts
 **/